import { Referrals, UserProfile } from "../../contract/pam.js";
class ReferralsExtended extends Referrals {
  personal_referral_link;
}
class UserProfileExtended extends UserProfile {
  aal_values;
  master_agent_id;
}
const agentReferrerFilterKeys = ["defaultReferrerPlayerId", "defaultIsDownstream", "referrerPlayerId", "isDownstream"];
class SecurityCaseViewModel {
  case_id;
  closed_at;
  opened_at;
  type;
}
class AgentPokerShareWeeklyBandViewModel {
  lower_bound;
  upper_bound;
  revenue_share;
}
class AgentPokerShareViewModel {
  weekly_bands;
}
class AgentPokerCashViewModel {
  plo;
  squid;
  allin_fold;
  nlh_sd;
}
const pokerCashSubTypesValues = ["PokerNgr", "PokerGgr", "PokerGgrNoInsurance"];
const pokerMttSubTypesValues = ["MttGgr"];
const pokerCashPloSubTypesValues = ["PloGgr", void 0];
const casinoSubTypesValues = ["CasinoGgrAfterExternalCosts", "CasinoGgr", "CasinoWager"];
const sportsSubTypesValues = ["SportsWager", "SportsGgr"];
const globalSpinsSubTypesValues = ["GlobalSpinsGgr"];
class AgentRevenueShareViewModel {
  active_since;
  casino_share;
  net_deposit_share;
  player_winloss;
  gross_deposit;
  spins;
  poker_mtt;
  sports;
  poker_cash;
  poker_share;
  commission_subtypes;
}
class AgentInfoViewModel {
  revenue_share_history;
}
class UserProfileViewModel {
  uid;
  uid_link_security;
  uid_link_cs;
  uid_link_agent;
  username;
  security_cases;
  agent_info;
  account_status;
  deposit_status;
  casino_status;
  withdrawal_status;
  lobby_access_status;
  p2p_transfer_status;
  sportsbook_status;
  brand;
  license_type;
  p2p_override_status;
  p2p_status;
  labels;
}
class AalViewModel {
  isRowUser;
  isOtherUser;
}
class UserProfileDownloadModel {
  "referral.personal_referral_code";
  uid;
  full_name;
  nickname;
  uid_link_security;
  uid_link_cs;
  uid_link_agent;
  uid_link_player_details;
  uid_link_agent_details;
  account_status;
  withdrawal_status;
  deposit_status;
  security_cases;
  platform;
  platform_narrow;
  sportsbook_status;
  "latest_kyc.payment.account_verification_status";
  "latest_kyc.payment.account_verification_status_cs";
  phone;
  verified_phone;
  referrer_player_id;
  referrer_username;
  email;
  verified_email;
  username;
  first_name;
  last_name;
  "phone.area";
  "phone.number";
  "birthday.seconds";
  "latest_login.logged_at_ts.seconds";
  gender;
  "date_of_joining.seconds";
  is_2fa_enabled;
  is_challenge_questions_enabled;
  p2p_transfer_status;
  "finance.balance";
  "finance.withdrawal.total.pending_count";
  referred_date;
  country;
  lobby_access_status;
  "security_cases.type";
  "security_cases.case_id";
  "security_cases.opened_at";
  "security_cases.closed_at";
  "latest_kyc.security.id";
  "latest_kyc.security.account_verification_status";
  deposit_total;
  withdrawal_approved_amount;
  withdrawal_approved_count;
  withdrawal_pending_amount;
  balance;
  ggr;
  lifetime_bonus;
  bonus_ratio;
  "agent_info.is_agent";
  "agent_info.default_agent_revenue_share_history";
  "agent_info.latest_revenue_share.casino_share";
  "agent_info.latest_revenue_share.poker_cash.nlh_sd";
  "agent_info.latest_revenue_share.poker_cash.plo";
  "agent_info.latest_revenue_share.poker_mtt";
  "agent_info.latest_revenue_share.spins";
  "agent_info.latest_revenue_share.sports";
  referrer;
  register_marketing_code;
  labels;
  national_id;
  networks_BL;
  networks_PKW;
  casino_status;
  "referral.personal_referral_link";
  ndrp_status;
  aml_labels;
  login_countries;
  vpn;
  "networks.uid";
  "networks.platform";
  "latest_kyc.payment.id";
  brand;
  license_type;
  "finance.casino_coin_balance";
  "finance.p2p_credit.successful_amount";
  "finance.p2p_debit.successful_amount";
  "finance.withdrawable_balance";
  casino_ggr_lifetime;
  poker_ggr_lifetime;
  sports_ggr_lifetime;
  withdrawal_total;
  aal;
  p2p_override_status;
  p2p_status;
  commission_subtypes;
  master_agent_id;
  channel;
  "finance.non_withdrawable_balance";
}
export {
  AalViewModel,
  AgentInfoViewModel,
  AgentPokerCashViewModel,
  AgentPokerShareViewModel,
  AgentPokerShareWeeklyBandViewModel,
  AgentRevenueShareViewModel,
  ReferralsExtended,
  SecurityCaseViewModel,
  UserProfileDownloadModel,
  UserProfileExtended,
  UserProfileViewModel,
  agentReferrerFilterKeys,
  casinoSubTypesValues,
  globalSpinsSubTypesValues,
  pokerCashPloSubTypesValues,
  pokerCashSubTypesValues,
  pokerMttSubTypesValues,
  sportsSubTypesValues
};
//# sourceMappingURL=types.js.map
